import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg3DPrintingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "3D printing" }),
		/* @__PURE__ */ _jsxs("g", {
			stroke: "var(--icon-outline)",
			strokeWidth: 2.4,
			strokeLinejoin: "round",
			strokeLinecap: "round",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "icon-white",
					d: "m10 65 40-23 40 23v5L50 93 10 70Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m10 65 40 23 40-23M50 88v5",
					fill: "none"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-white",
					d: "M19 61V19l6-3v42ZM75 61V19l6-3v42Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-white",
					d: "m19 19 6-4h56v7l-6 4H19Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19 19h56v7m0-7 6-4",
					fill: "none"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-white",
					d: "M44 26h12v9l-4 5v6h-4v-6l-4-5Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-white",
					d: "m32 65 18-10 18 10v9L50 84 32 74Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m32 65 18 10 18-10M50 75v9",
					fill: "none"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "none",
			stroke: "var(--icon-highlight)",
			strokeWidth: 2.4,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [/* @__PURE__ */ _jsx("path", { d: "M50 47v7m-14 14 14 8 14-8m-28 5 14 8 14-8" }), /* @__PURE__ */ _jsx("path", { d: "m38 65 12-7 12 7-12 7Z" })]
		})
	]
});
export default Svg3DPrintingSm;
